const de = {
  firstDayWeek: 'erster tag der woche',
  startScreen: 'Startbildschirm',
  blackTheme: 'Schwarzes Thema',
  backgroundImage: 'Hintergrundbild',
  language: 'Sprache',
  sounds: 'Klänge',
  home: 'Haus',
  calendar: 'Kalender',
  settings: 'Einstellungen',
  noTasks: 'Keine aufgaben',
  myTasks: 'Meine aufgaben',
  chooseImage: 'Wählen sie ein Hintergrundfoto:',
  saveChanges: 'Änderungen speichern',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  close: 'SCHLIESSEN',
  taskManager: 'Task-Manager'
};

export default de;
